export const initialFilterState = {
    dc: [],
    groupType: {
        id: 1,
        name: 'sap',
    },
    custGroup: [],
    parahub: [],
    dateSellout: {},
    dateUpload: {},
    selloutType: {},
    status: [],
};
